import PptxGenJS from "pptxgenjs";
import { getTemplate, PresentationTemplate } from "./templates/rra";

export interface GeneratePowerpointOptions {
  templateName: string;
  data: any; // Union of different slide data types, e.g., TitleSlideData
  fileName?: string;
}

export class PowerpointGenerator {
  private pres: PptxGenJS;

  constructor() {
    this.pres = new PptxGenJS();
    this.pres.theme = {
      bodyFontFace: "Arial",
      headFontFace: "Times New Roman",
    };
    this.pres.defineLayout({ name: "PPT_16_9", width: 16, height: 9 });

    this.pres.layout = "PPT_16_9";
  }

  private defineMasterSlides(template: PresentationTemplate): void {
    Object.entries(template.masterSlides).forEach(([masterName, masterDef]) => {
      const finalMasterOpts: PptxGenJS.SlideMasterProps = {
        ...masterDef,
        title: masterName,
      };

      this.pres.defineSlideMaster(finalMasterOpts);
    });
  }

  private addSlidesFromTemplate(
    template: PresentationTemplate,
    data: any
  ): void {
    template.slides.forEach((addSlideFn) => {
      addSlideFn(this.pres, data);
    });
  }

  public async generatePresentation(
    options: GeneratePowerpointOptions
  ): Promise<void | string | Blob> {
    const template = getTemplate(options.templateName);

    if (!template) {
      throw new Error(`Template "${options.templateName}" not found.`);
    }

    this.defineMasterSlides(template);
    this.addSlidesFromTemplate(template, options.data);

    const fileName =
      options.fileName ||
      `${template.name.replace(/\s+/g, "_")}_${new Date().toISOString()}.pptx`;

    return this.pres.writeFile({ fileName });
  }
}
